module.exports = __webpack_public_path__ + "media/assets/images/logos/bulloni_digitali_logo-5bd9ce8de143c95a5b0027b3591b4090.png";